<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> توقف های ترانزیت </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <div class="container-fluid row gx-0 gy-0 mt-0">

        <!-- نمایش روی نقشه -->

        <div class="col-12 col-md-auto position-relative px-md-2">

            <button class="w-100 btn btn-warning" >

                &nbsp; نمایش روی نقشه &nbsp;

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative px-md-2">

            <button class="w-100 btn btn-success" >

                &nbsp; خروجی اکسل &nbsp;

            </button>

        </div>

    </div>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="section border border-2 mt-2" style="height:calc(100vh - 190px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center"> # </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> زمان </th>
                        
                        <th class="text-center"> مدت </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of [];let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="">

                            <i class="fa fa-stop-circle fa-lg pointer" title="توقف ها" (click)="openRoute_Stops(item)"></i>

                            <i class="fa fa-road mx-2 fa-lg pointer" title="مسیر" (click)="open_Location(item)"></i>
                            
                        </th>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strFullName | faNum }} </td>

                        <td> {{ item.strRoute | faNum }} </td>

                        <td> {{ item.strMobileType_strComment | faNum }} </td>

                        <td> {{ item.strResultTime | faNum }} </td>

                        <td> {{ item.strSDuration | faNum }} </td>

                        <td> {{ item.strDDuration | faNum }} </td>

                        <td> {{ item.iStops | faNum }} </td>

                        <td> {{ item.strResultTrip | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>